import { render, staticRenderFns } from "./SysStaff.vue?vue&type=template&id=8bec1888"
import script from "./SysStaff.vue?vue&type=script&lang=js"
export * from "./SysStaff.vue?vue&type=script&lang=js"
import style0 from "./SysStaff.vue?vue&type=style&index=0&id=8bec1888&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports